// AuthGate — entscheidet welcher Screen angezeigt wird
import React, { useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';
import { loadSalt } from '../../services/crypto';
import { SetupWizard } from './SetupWizard';
import { LoginScreen } from './LoginScreen';

interface Props {
  children: React.ReactNode;
}

export function AuthGate({ children }: Props): React.JSX.Element {
  const { step, setStep, setSetupComplete } = useAuthStore();

  // Beim Start prüfen: Ist Setup bereits durchgeführt?
  useEffect(() => {
    if (step !== 'checking') return;
    loadSalt()
      .then(salt => {
        if (salt === null) {
          setSetupComplete(false);
          setStep('setup-new');
        } else {
          setSetupComplete(true);
          setStep('login');
        }
      })
      .catch(() => {
        setStep('setup-new');
      });
  }, [step, setStep, setSetupComplete]);

  if (step === 'checking') {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-blue-700 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (step === 'setup-new' || step === 'setup-confirm' || step === 'setup-recovery') {
    return <SetupWizard />;
  }

  if (step === 'login') {
    return <LoginScreen />;
  }

  // step === 'unlocked'
  return <>{children}</>;
}
